import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const QuickActionPanel = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 'full-practice',
      title: 'Full Practice Test',
      description: 'Complete 150-question exam simulation',
      icon: 'FileText',
      iconBg: 'bg-primary',
      path: '/question-practice',
      params: { mode: 'full', questions: 150 }
    },
    {
      id: 'knowledge-area',
      title: 'Knowledge Area Focus',
      description: 'Practice specific BABOK domains',
      icon: 'Target',
      iconBg: 'bg-secondary',
      path: '/question-practice',
      params: { mode: 'knowledge-area' }
    },
    {
      id: 'weak-areas',
      title: 'Weak Areas Review',
      description: 'Focus on your challenging topics',
      icon: 'TrendingUp',
      iconBg: 'bg-warning',
      path: '/question-practice',
      params: { mode: 'weak-areas' }
    },
    {
      id: 'quick-quiz',
      title: 'Quick Quiz',
      description: '20 random questions for quick practice',
      icon: 'Zap',
      iconBg: 'bg-accent',
      path: '/question-practice',
      params: { mode: 'quick', questions: 20 }
    },
    {
      id: 'view-analytics',
      title: 'View Analytics',
      description: 'Check your performance metrics',
      icon: 'BarChart3',
      iconBg: 'bg-success',
      path: '/results-analytics',
      params: {}
    },
    {
      id: 'study-materials',
      title: 'Study Materials',
      description: 'Access BABOK guides and resources',
      icon: 'BookOpen',
      iconBg: 'bg-primary',
      path: '/resources',
      params: {}
    }
  ];

  const handleActionClick = (action) => {
    const queryParams = new URLSearchParams(action.params)?.toString();
    const path = queryParams ? `${action?.path}?${queryParams}` : action?.path;
    navigate(path);
  };

  return (
    <div className="quick-action-panel animate-fade-in">
      <div className="quick-action-header">
        <h2 className="quick-action-title">Quick Actions</h2>
        <p className="quick-action-description">
          Start your practice session or review your progress
        </p>
      </div>
      <div className="quick-action-grid">
        {quickActions?.map((action) => (
          <div
            key={action?.id}
            className="quick-action-card"
            onClick={() => handleActionClick(action)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e?.key === 'Enter' || e?.key === ' ') {
                e?.preventDefault();
                handleActionClick(action);
              }
            }}
          >
            <div className={`quick-action-card-icon ${action?.iconBg}`}>
              <Icon name={action?.icon} size={24} color="white" />
            </div>
            <h3 className="quick-action-card-title">{action?.title}</h3>
            <p className="quick-action-card-description">{action?.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActionPanel;